import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  Menu,
  MenuItem as MuiMenuItem,
} from '@material-ui/core';
import { getBoundingClientRect } from '../../../styled-base/menu/utils';
import { getAiTypeDefinitions } from '../../utils';
import { AiTypeIcon } from './aiTypeIcon';
import { AiTypeMenuProps } from './types';

const MenuItem = styled(MuiMenuItem)`
  gap: 8px;
`;

export function AiTypeMenu ({
  anchorEl,
  hideTitle,
  onClose,
  onTypeSelected,
  selectedType,
}: AiTypeMenuProps) {
  const { t } = useTranslation();
  let anchorPosition;
  const open = Boolean(anchorEl);
  if (open) {
    const {
      height,
      left,
      top,
      width,
    } = getBoundingClientRect(anchorEl);
    anchorPosition = {
      left: left + width,
      top: top + height + 4,
    };
  }

  const handleMenuClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  const handleMenuItemClick = (e, newType) => {
    e.preventDefault();
    e.stopPropagation();
    if (selectedType !== newType) {
      onTypeSelected(newType);
    }
  };

  return (
    <Menu
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      container={document.fullscreenElement}
      disableScrollLock
      open={open}
      onClose={handleMenuClose}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {!hideTitle && (
        <MenuItem disabled>{t('Type')}</MenuItem>
      )}
      {getAiTypeDefinitions().map(
        (type) => (
          <MenuItem
            key={type.id}
            selected={type.id === selectedType}
            onClick={(e) => handleMenuItemClick(e, type.id)}
          >
            <AiTypeIcon
              type={type.id}
            />
            {type.label}
          </MenuItem>
        )
      )}
    </Menu>
  );
}
